// src/pages/TestimonialsPage.js
import React, { useEffect } from 'react';
import './TestimonialsPage.css';
import TestimonialCard from '../components/TestimonialCard';
import SEO from "../components/SEO";
import { PAGES_SEO } from "../seo/pagesSeo";

export default function TestimonialsPage() {
    const seo = PAGES_SEO.testimonials;
    useEffect(() => {
        const elements = document.querySelectorAll('.fade-in');
        elements.forEach((element, index) => {
            setTimeout(() => {
                element.classList.add('visible');
            }, index * 200);
        });
    }, []);

    const testimonials = [
        {
            id: 1,
            name: 'Marie Dupont',
            image: '/images/testimonial1.jpg',
            quote:
                'Une expérience incroyable ! Les pièces sont magnifiques et le service est exceptionnel.',
        },
        {
            id: 2,
            name: 'Jean Martin',
            image: '/images/testimonial2.jpg',
            quote:
                'Un large choix d\'antiquités authentiques. J\'ai trouvé exactement ce que je cherchais.',
        },
        {
            id: 3,
            name: 'Sophie Bernard',
            image: '/images/testimonial3.jpg',
            quote:
                'Le personnel est très compétent et passionné. Je recommande vivement cette boutique.',
        },
        {
            id: 4,
            name: 'Pierre Lefevre',
            image: '/images/testimonial4.jpg',
            quote:
                'Un service client exceptionnel. J\'ai été impressionné par la qualité des produits.',
        },
        {
            id: 5,
            name: 'Camille Robert',
            image: '/images/testimonial5.jpg',
            quote:
                'Une collection unique d\'antiquités. Je suis ravi de mon achat et je reviendrai bientôt.',
        },
        {
            id: 6,
            name: 'Lucas Moreau',
            image: '/images/testimonial6.jpg',
            quote:
                'Des pièces rares et fascinantes. Un vrai trésor pour les amateurs d\'histoire et d\'art.',
        }
    ];

    return (
        <>
        <SEO title={seo.title} description={seo.description} path={seo.path} />
        <div className="testimonials-page">
            <h1 className="fade-in">Ce Que Disent Nos Clients</h1>
            <div className="testimonials-grid">
                {testimonials.map((testimonial) => (
                    <TestimonialCard key={testimonial.id} testimonial={testimonial} />
                ))}
            </div>
        </div>
        </>
    );
}
